// Third-party code, disable linting
/* eslint-disable */
import { DEFAULT_LANGUAGE } from '@jpi-cloud-web-pro/jpi-cloud-shared/config/common';
import { getFromLocalStorageByKey } from '../../utils/localStorage';

function getSiteLanguage() {
  if (document.documentElement.lang) {
    return normalizeLang(document.documentElement.lang);
  }

  const langFromStorage = getFromLocalStorageByKey('LAST_USED_LANGUAGE');

  if (langFromStorage) {
    return normalizeLang(langFromStorage);
  }

  const browserLanguage = getBrowserLanguage();
  if (browserLanguage) {
    return browserLanguage;
  }
  return DEFAULT_LANGUAGE;
}

function getBrowserLanguage() {
  const browserLanguages = Array.isArray(navigator.languages) ? navigator.languages : [];
  const language = browserLanguages.find(Boolean) || navigator.language;
  if (!language) {
    return null;
  }
  return normalizeLang(language);
}

function normalizeLang(lang) {
  if (lang === 'nb') {
    return 'no';
  }
  return lang.toLowerCase().split('-')[0];
}

const language = getSiteLanguage();

const mobileAppWebViewUrlArray = [
  'terms-of-service-step',
  'privacy-policy-step',
  'product-registration-info',
  'warranty',
];

const mobileAppWebView = mobileAppWebViewUrlArray.some(s => window.location.pathname.includes(s));

const isLocalhost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
const cookieYesKey = process.env.REACT_APP_COOKIEYES_KEY;

if (!mobileAppWebView && !isLocalhost && cookieYesKey) {
  window.cookieyesConfig = {
    lang: language,
  };

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.id = 'cookieyes';
  script.src = `https://cdn-cookieyes.com/client_data/${cookieYesKey}/script.js`;
  script.setAttribute('charset', 'UTF-8');
  document.getElementsByTagName('head')[0].appendChild(script);
}
